import React, { FC, useMemo } from 'react';
import { EmptyState } from '../empty_state/EmptyState';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/parts_equipments_work_orders_actions';
import { partsEquipmentsWorkOrdersRestCrudThunksForSupplier } from '../../thunks/parts_equipments_work_orders_thunks';
import PaginatedReduxTable from '../paginated_redux_table/PaginatedReduxTable';
import EquipmentInServiceCallRowDisplay from './EquipmentInServiceCallRowDisplay';

const TC_NAME = 'workOrderAddedEPSLIndex';

const WorkOrderEquipmentSection: FC<any> = ({
	onRemoveEquipment,

	updateFilters,
	clearAndUpdateFilters,
	workOrdersPartsEquipment,
	match,
}): React.ReactElement => {
	const workOrderId = useMemo(() => match.params.id, [match.params.id]);

	const columns = [
		{
			title: 'ID',
			dataIndex: 'id',
			sorter: true,
			render: (text, record) => (
				<EquipmentInServiceCallRowDisplay
					equipmentInWorkOrder={record}
					onConfirmRemove={onRemoveEquipment(record)}
				/>
			),
		},
	];

	return (
		<PaginatedReduxTable
			targetCollectionName={TC_NAME}
			updateFilters={updateFilters}
			stateSlice={workOrdersPartsEquipment}
			clearAndUpdateFilters={clearAndUpdateFilters}
			filterConfig={[]}
			collectionName="work_orders_parts_equipment"
			columns={columns}
			fetchData={partsEquipmentsWorkOrdersRestCrudThunksForSupplier.read}
			rightActions={null}
			hideFilters
			showHeader={false}
			initialFilters={{ workOrderId, isEquipmentLine: true }}
			emptyState={
				<EmptyState
					graphic={
						<img
							alt="No Data"
							style={{ marginBottom: 8 }}
							src="https://s3.amazonaws.com/mock-data-assets/categories/images/box.svg"
						/>
					}
					headline={'No Equipment Added'}
					body={null}
				/>
			}
		/>
	);
};

const mapStateToProps = (state) => ({
	workOrdersPartsEquipment: state.work_orders_parts_equipment,
	companyConfig: state.company_config.detail,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	updateFilters: (filters, targetCollection) =>
		dispatch(
			PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)
		),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(
			PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(
				filters,
				targetCollectionName
			)
		),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(WorkOrderEquipmentSection)
);
